<style scoped>
    .btn.disabled {
        cursor: auto;
    }
</style>

<template>
    <b-form class="c-form" v-on:submit.prevent="submit" v-on:reset.prevent="reset" novalidate>
        <FormRows v-model="fieldRefs" :fieldRefs="fieldRefs" :rows="dataRows" :form="$v.form">
            <template v-for="row, rowIndex in dataStructure.rows">
                <template v-for="col, colIndex in row.cols">
                    <template :form="form" v-if="col.cards !== undefined" :cards="col.cards">
                        <slot v-for="card in col.cards" v-if="card.key !== ''" :slot="card.key">
                            <slot :name="card.key"></slot>
                        </slot>
                    </template>
                </template>
            </template>
        </FormRows>
        <slot name="afterForm"></slot>
        <div class="mb=-3 text-right">
            <b-button-group>
                <slot name="beforeFormButtons"></slot>
                <b-button :class="options.reset.classes"  v-if="false && options.reset !== undefined && options.reset.text !== undefined &&  options.reset.text !== ''" class="mr-2" type="reset" :style="{ 'background-color':  Core.Session.Setting.getSetting('environment.ui.login.loginButtonBGColor', '', Core.Value.typeColor) , 'border-color':  Core.Session.Setting.getSetting('environment.ui.login.loginButtonBorderColor', '', Core.Value.typeColor), 'color':  Core.Session.Setting.getSetting('environment.ui.login.loginButtonTextColor', '', Core.Value.typeColor)}" :disabled="!isDirty">
                    {{options.reset.text}}
                </b-button>
                <b-button :disabled="dataSecurityBlock" :class="options.submit.classes" v-if="options.submit !== undefined && options.submit.text !== undefined && options.submit.text !== ''" type="submit" :style="{ 'background-color':  Core.Session.Setting.getSetting('environment.ui.login.loginButtonBGColor', '', Core.Value.typeColor) , 'border-color':  Core.Session.Setting.getSetting('environment.ui.login.loginButtonBorderColor', '', Core.Value.typeColor), 'color':  Core.Session.Setting.getSetting('environment.ui.login.loginButtonTextColor', '', Core.Value.typeColor)}" v-html="options.submit.text"></b-button>
                <slot name="afterFormButtons"></slot>
            </b-button-group>
        </div>
        <div style="clear: both"></div>
        <slot name="bottomForm"></slot>
    </b-form>
</template>

<script>
    import {validationMixin} from "vuelidate"
    import {required, minLength, email, sameAs, helpers, requiredIf} from "vuelidate/lib/validators"
    import FormRows from './FormRows'

    const mustAccept = value => {
        return Boolean(value)
    }
    const strongPass = helpers.regex('strongPass', /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/)

    const isCool = (field) => (value) => {

        if (field.required === undefined) {
            return true
        }

        if (field.required !== undefined && field.required === true && (value === ''||value === undefined||value===null)) {
            return false
        }

        if (field.minLength !== undefined && field.minLength > 0 && value.length < field.minLength) {
            return false
        }

        switch (field.type) {
            case Core.Value.typeCheckbox:
                if (field.required !== undefined && field.required === true) {
                    if (value == 0) {
                        return false
                    }
                }
                break
            case Core.Value.typeInstanceSelector:
                if (value.id === undefined || !Core.Validation.isId(value)) {
                    return false
                }
                break
            case Core.Value.typeEmail:
                if (!email(value)) {
                    return false
                }
                break
            case Core.Value.typePhone:
                if (value!==null&&value!==''&&value!==undefined) {
                    if (value.match(/^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/) == null) {
                        return false
                    }
                }
                break
            case Core.Value.typeProductLimitedSubscriptionSummary:
                if (Array.isArray(value)) {
                    if (value.length === 0) {
                        return false
                    }
                }
                break
            case Core.Value.typeProductStandardSummary:
                if (Array.isArray(value)) {
                    if (value.length === 0) {
                        return false
                    }
                }
                break
        }
        return true
    }

    export default {
        name: 'CForm',
        components: {
            FormRows
        },
        watch: {
            $v: {
                handler: function (val) {
                    if (!val.$invalid) {
                        this.$emit('can-continue', {value: true});
                    } else {
                        this.$emit('can-continue', {value: false});
                    }
                },
                deep: true
            },
            clickedNext(val) {
                if (val === true) {
                    this.$v.form.$touch();
                }
            },
            structure: {
                handler: function (val) {
                    this.dataStructure = this.structure
                },
                deep: true
            },
            dataStructure: {
                handler: function (val) {
                    this.fieldFields = []
                    this.form = this.buildFormShape(val)
                    this.dataRows = this.buildForm(val.rows, val.fields)
                },
                deep: true
            }
        },
        props: {
            value: {
                type: Object,
                default: function() {}
            },
            options: {
                type: Object,
                default: function() {
                    return {
                        validation: false,
                        submit: {
                            text: '',
                            variant: 'success'
                        },
                        reset: {
                            text: '',
                            variant: 'light'
                        }
                    }
                }
            },
            structure: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            clickedNext: {
                type: Boolean,
                default: false
            },
            currentStep: {
                type: Object,
                default: function() { return {}}
            }
        },
        computed: {
            isValid() {
                return !this.$v.form.$anyError
            },
            isDirty() {
                return this.$v.form.$anyDirty
            },
            securityBlock: {
                set(val) {
                    this.dataSecurityBlock = val
                },
                get() {
                    return this.dataSecurityBlock
                }
            }
        },
        mixins: [validationMixin],
        validations() {
            return this.buildValidations(this.dataStructure)
        },
        mounted() {
            this.dataStructure = this.structure
            this.dataRows = this.buildForm(this.dataStructure.rows, this.dataStructure.fields)
            if (!this.$v.$invalid) {
                this.$emit('can-continue', {value: true});
            } else {
                this.$emit('can-continue', {value: false});
            }
        },
        data() {
            return {
                Core: window.Core,
                form: Object.assign({}, this.buildFormShape(this.structure)),
                feedBack: 'secondary',
                submitted: false,
                dataRows: [],
                v: this.$v,
                fieldRefs: [],
                dataStructure: {},
                dataSecurityBlock: false
            }
        },
        methods: {
            getValues() {
                let values = {}
                for(let key in this.form) {
                    let value = this.form[key]
                    values[key] = value
                }

                return values
            },
            getValue(key) {
                return this.form[key]
            },
            setValue(key, value) {
                this.form[key] = value
            },
            buildForm(rows, fields) {
                for (let rowIndex in rows) {
                    let row = rows[rowIndex]
                    for (let colIndex in row.cols) {
                        let col = row.cols[colIndex]
                        if (undefined !== col.fields) {
                            for (let fieldIndex in col.fields) {
                                let field = col.fields[fieldIndex]
                                if (undefined !== field.id) {
                                    field = Core.Array.findByKey(fields, 'id', field.id)
                                }
                                col.fields[fieldIndex] = field
                            }
                        }
                        if (undefined !== col.cards) {
                            for (let cardIndex in col.cards) {
                                let card = col.cards[cardIndex]
                                if (undefined !== card.tabs) {
                                    for (let tabIndex in card.tabs) {
                                        let tab = card.tabs[tabIndex]
                                        if (undefined !== tab.fields) {
                                            for (let fieldIndex in tab.fields) {
                                                let field = tab.fields[fieldIndex]
                                                if (undefined !== field.id) {
                                                    field = Core.Array.findByKey(fields, 'id', field.id)
                                                }
                                                tab.fields[fieldIndex] = field
                                            }
                                        }
                                        if (undefined !== tab.rows) {
                                            tab.rows = this.buildForm(tab.rows, fields)
                                        }
                                        card.tabs[tabIndex] = tab
                                    }
                                }
                                if (undefined !== card.fields) {
                                    for (let fieldIndex in card.fields) {
                                        let field = card.fields[fieldIndex]
                                        if (undefined !== field.id) {
                                            field = Core.Array.findByKey(fields, 'id', field.id)
                                        }
                                        card.fields[fieldIndex] = field
                                    }
                                }
                                if (undefined !== card.rows) {
                                    card.rows = this.buildForm(card.rows, fields)
                                }
                                col.cards[cardIndex] = card
                            }
                        }
                        if (undefined !== col.rows) {
                            col.rows = this.buildForm(col.rows, fields)
                        }
                        row.cols[colIndex] = col
                    }
                    rows[rowIndex] = row
                }
                return rows
            },
            buildFormShape(form) {
                let formShape = {}
                if (form !== undefined && form.fields !== undefined) {
                    for (let field in form.fields) {
                        field = form.fields[field]
                        formShape[field.id] = field.value
                    }
                }
                return formShape
            },
            buildValidations(form) {
                let validationSchema = {
                    form: {}
                }
                if (form !== undefined && form.fields !== undefined) {
                    for (let field in form.fields) {
                        field = form.fields[field]
                        validationSchema.form[field.id] = {
                            mustBeCool: isCool(field)
                        }
                    }
                }
                return validationSchema
            },
            submit() {
                console.log(this.validate())
                if (this.validate()) {
                    this.$nextTick(() => {
                        this.$emit('onSubmit', this.$v.form.$model, this.fieldRefs, this.dataStructure)
                    })
                }
            },
            reset() {
                this.form = Object.assign({}, this.buildFormShape(this.structure))
                this.submitted = false
                this.$nextTick(() => {
                    this.$v.$reset()
                    this.$emit('onReset', this.$v.form.$model, this.fieldRefs, this.dataStructure)
                })
            },
            findFirstError(component = this) {
                if (component.state === false) {
                    if (component.$refs.input) {
                        component.$refs.input.focus()
                        return true
                    }
                    if (component.$refs.check) {
                        component.$refs.check.focus()
                        return true
                    }
                }
                let focused = false
                component.$children.some((child) => {
                    focused = this.findFirstError(child)
                    return focused
                })
                return focused
            },
            chkState(val) {
                const field = this.$v.form[val]
                return !field.$dirty || !field.$invalid
            },
            validate() {
                this.$v.$touch()
                this.$nextTick(() => this.findFirstError())
                this.$emit('onValidate', this.$v.form.$model, this.fieldRefs, this.dataStructure)
                return this.isValid
            }
        }
    }
</script>
